import React, { useState } from 'react';

/**
 * Componente para exibir imagens de demandas de forma otimizada
 */
export default function ImagemDemanda({ 
  src, 
  alt = "Imagem da demanda", 
  width = "100px", 
  height = "100px",
  className = ""
}) {
  const [showModal, setShowModal] = useState(false);
  const [imageError, setImageError] = useState(false);

  if (!src || imageError) {
    return (
      <div 
        className={`imagem-placeholder ${className}`}
        style={{
          width,
          height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '8px',
          color: '#6c757d',
          fontSize: '12px',
          cursor: 'default'
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <i className="fas fa-image" style={{ fontSize: '20px', marginBottom: '4px' }}></i>
          <div>Sem imagem</div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Thumbnail clicável */}
      <div 
        className={`imagem-thumbnail ${className}`}
        style={{
          width,
          height,
          borderRadius: '8px',
          overflow: 'hidden',
          cursor: 'pointer',
          border: '1px solid #e9ecef',
          position: 'relative',
          transition: 'transform 0.2s ease'
        }}
        onClick={() => setShowModal(true)}
        onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
      >
        <img
          src={src}
          alt={alt}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          onError={() => setImageError(true)}
        />
        
        {/* Overlay com ícone de zoom */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0,
            transition: 'opacity 0.2s ease'
          }}
          onMouseEnter={(e) => e.target.style.opacity = '1'}
          onMouseLeave={(e) => e.target.style.opacity = '0'}
        >
          <i className="fas fa-search-plus" style={{ color: 'white', fontSize: '16px' }}></i>
        </div>
      </div>

      {/* Modal para exibir imagem em tamanho completo */}
      {showModal && (
        <div 
          className="modal-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
          }}
          onClick={() => setShowModal(false)}
        >
          <div 
            style={{
              position: 'relative',
              maxWidth: '90vw',
              maxHeight: '90vh',
              backgroundColor: 'white',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Botão de fechar */}
            <button
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'rgba(0,0,0,0.7)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px',
                zIndex: 1001
              }}
              onClick={() => setShowModal(false)}
            >
              <i className="fas fa-times"></i>
            </button>

            {/* Imagem em tamanho completo */}
            <img
              src={src}
              alt={alt}
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '90vh',
                objectFit: 'contain',
                display: 'block'
              }}
            />

            {/* Informações da imagem */}
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                color: 'white',
                padding: '20px',
                fontSize: '14px'
              }}
            >
              <div>{alt}</div>
              <div style={{ fontSize: '12px', opacity: 0.8, marginTop: '4px' }}>
                Clique fora da imagem para fechar
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}